export interface LocalStorageValueMap {
    feedbackTop: boolean
    mobile_verification: unknown //  TODO - replace with actual type
    apply_dialog: unknown //  TODO - replace with actual type
    service_code: unknown //  TODO - replace with actual type
    is_logged: unknown //  TODO - replace with actual type
    after_apply: unknown //  TODO - replace with actual type
    applying_process: unknown //  TODO - replace with actual type
    after_apply_id: unknown //  TODO - replace with actual type
    after_apply_title: unknown //  TODO - replace with actual type
}

export type LocalStorageKey = keyof LocalStorageValueMap

export function setLocalStorageItem<K extends LocalStorageKey>(key: K, value: LocalStorageValueMap[K]): void {
    try {
        const serializedValue = JSON.stringify(value)
        localStorage.setItem(key, serializedValue)
    } catch (error) {
        console.error(`[LocalStorage] Failed to set item with key "${key}":`, error)
    }
}

export function getLocalStorageItem<K extends LocalStorageKey>(
    key: K,
    defaultValue?: LocalStorageValueMap[K]
): LocalStorageValueMap[K] | null {
    try {
        const value = localStorage.getItem(key)
        if (value !== null) {
            return JSON.parse(value) as LocalStorageValueMap[K]
        }
        return defaultValue ?? null
    } catch (error) {
        console.error(`[LocalStorage] Failed to get item with key "${key}":`, error)
        return defaultValue ?? null
    }
}

export function removeLocalStorageItem(...keys: LocalStorageKey[]): void {
    keys.forEach((key) => {
        try {
            localStorage.removeItem(key)
        } catch (error) {
            console.error(`[LocalStorage] Failed to remove key "${key}":`, error)
        }
    })
}
